module.exports = __webpack_public_path__ + "assets/3f6d6d096f90d9fd8bb51bda87a7f8a2.png";